import CadastroConvidado from './CadastroConvidado'

export default CadastroConvidado